export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const stats = [
    { value: '18+', label: 'лет практики' },
    { value: '100+', label: 'корпоративных проектов' },
    { value: '450+', label: 'тренингов и сессий' },
    { value: '4500+', label: 'участников' },
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/a74a1966-be20-475d-bd44-2c6a9fc46c98/79a8809d-8c54-416a-8e29-3ff1f86d1c7c_compressed_IMG_0086.webp"
          alt="Алексей Сивко — бизнес-тренер по продажам и переговорам"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] min-w-full h-[56.25vw] min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/65 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-32 md:pt-24 pb-12 md:pb-16">
        <div className="grid lg:grid-cols-5 gap-8 lg:gap-12 items-center">
          {/* Left - Photo + Stats */}
          <div className="lg:col-span-2">
            <div className="relative">
              <div className="w-56 h-56 md:w-72 md:h-72 mx-auto lg:mx-0 rounded-2xl overflow-hidden border-4 border-white/20 shadow-2xl">
                <img
                  src="https://storage.readdy-site.link/project_files/a74a1966-be20-475d-bd44-2c6a9fc46c98/e710e42b-e287-430c-bcda-0bcd98ae0d26_compressed_IMG_1156.webp"
                  alt="Алексей Сивко — бизнес-тренер"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="mt-6 grid grid-cols-2 gap-3">
                {stats.map((stat, i) => (
                  <div key={i} className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-xl p-3 md:p-4 text-center">
                    <div className="text-xl md:text-2xl font-extrabold text-teal-400">{stat.value}</div>
                    <div className="text-white/60 text-xs mt-0.5 leading-tight">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div className="lg:col-span-3">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-white mb-4 leading-tight">
              Алексей Сивко — бизнес-тренер по продажам, переговорам и развитию руководителей
            </h1>
            <p className="text-sm md:text-lg text-white/80 mb-8 leading-relaxed max-w-2xl">
              Практикующий бизнес-тренер, консультант и фасилитатор, который помогает компаниям внедрять изменения, а не просто проводить обучение. Работаю с командами из Беларуси, России, Казахстана, Узбекистана и Израиля.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => scrollTo('contact')}
                className="bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center"
              >
                Получить консультацию
                <i className="ri-arrow-right-line"></i>
              </button>
              <button
                onClick={() => scrollTo('contact')}
                className="border border-white/30 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-white/10 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center"
              >
                Подобрать программу
                <i className="ri-search-line"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="mt-12 flex justify-center">
          <button onClick={() => scrollTo('approach')} className="text-white/30 hover:text-white/70 transition-colors cursor-pointer animate-bounce">
            <i className="ri-arrow-down-line text-2xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}